import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";


export default class ShiftService extends AbstractService {
	static endpoint = ENDPOINTS.shifts;

	static jurisdictionShiftsFeature = "use_api_core_endpoints_jurisdiction_shifts";

	static jurisdictionShiftsApi = NexusService.jurisdictionShiftsApi;

	static getAll(queryParams) {
		if (FeatureFlagService.isEnabled(this.jurisdictionShiftsFeature)) {
			const request = {};
			if (Object.hasOwn(queryParams, "pageNumber")) {
				request.pageNumber = queryParams.pageNumber;
			}
			if (Object.hasOwn(queryParams, "displayCount")) {
				request.displayCount = queryParams.displayCount;
			}
			if (Object.hasOwn(queryParams, "officerName")) {
				request.officerName = queryParams.officerName;
			}
			if (Object.hasOwn(queryParams, "supervisorName")) {
				request.supervisorName = queryParams.supervisorName;
			}
			if (Object.hasOwn(queryParams, "shiftName")) {
				request.shiftName = queryParams.shiftName;
			}
			return this.jurisdictionShiftsApi.getPaginatedJurisdictionShifts(request)
				.then((response) => ({ data: response }));
		}
		return this.get({
			endpoint: this.endpoint,
			queryParams,
		});
	}

	static getById(id) {
		if (FeatureFlagService.isEnabled(this.jurisdictionShiftsFeature)) {
			return this.jurisdictionShiftsApi.getJurisdictionShift({ id }).then(response => ({ data: response
			}));
		}
		return this.get({
			endpoint: `${this.endpoint}/${id}`,
		});
	}

	static getOfficers(id, queryParams) {
		return this.get({
			endpoint: `${this.endpoint}/${id}`,
			queryParams,
		});
	}

	static add(data) {
		if (FeatureFlagService.isEnabled(this.jurisdictionShiftsFeature)) {
			const request = {
				jurisdictionShiftCreatePayload: {},
			};
			if (Object.hasOwn(data, "Name")) {
				request.jurisdictionShiftCreatePayload.Name = data.Name;
			}
			if (Object.hasOwn(data, "SupervisorId")) {
				request.jurisdictionShiftCreatePayload.SupervisorId = data.SupervisorId;
			}
			if (Object.hasOwn(data, "SecondarySupervisorId")) {
				request.jurisdictionShiftCreatePayload.SecondarySupervisorId = data.SecondarySupervisorId;
			}
			if (Object.hasOwn(data, "Officers")) {
				request.jurisdictionShiftCreatePayload.Officers = data.Officers;
			}
			return this.jurisdictionShiftsApi.createJurisdictionShift(request)
			.then(response => ({ data: response }));
		}
		return this.post({
			endpoint: this.endpoint,
			data,
		});
	}

	static edit(data) {
		if (FeatureFlagService.isEnabled(this.jurisdictionShiftsFeature)) {
			const request = {
				id: data.Id,
				jurisdictionShiftUpdatePayload: {},
			};
			if (Object.hasOwn(data, "Name")) {
				request.jurisdictionShiftUpdatePayload.Name = data.Name;
			}
			if (Object.hasOwn(data, "SupervisorId")) {
				request.jurisdictionShiftUpdatePayload.SupervisorId = data.SupervisorId;
			}
			if (Object.hasOwn(data, "SecondarySupervisorId")) {
				request.jurisdictionShiftUpdatePayload.SecondarySupervisorId = data.SecondarySupervisorId;
			}
			if (Object.hasOwn(data, "Officers")) {
				request.jurisdictionShiftUpdatePayload.Officers = data.Officers;
			}
			return this.jurisdictionShiftsApi.updateJurisdictionShift(request)
			.then(response => ({ data: response }));
		}
		return this.put({
			endpoint: `${this.endpoint}`,
			data,
		});
	}

	static delete(id) {
		if (FeatureFlagService.isEnabled(this.jurisdictionShiftsFeature)) {
			const request = {
				id,
			};
			return this.jurisdictionShiftsApi.deleteJurisdictionShift(request)
			.then(response => ({ data: response }));
		}
		return this.del({ endpoint: `${this.endpoint}/${id}` });
	}
}
